import type { FieldSpec, Schema } from '@wix/wix-data-schema-types'
import { AllowedFilterOperator } from '@wix/wix-data-schema-types'
import { SUPPRTED_FIELD_TYPES_IN_URL } from '../../business-data/dynamicPages'
import { isOwnerField } from '../fields/fieldQueries'
import { isDbDriverCollection } from '../collections/collectionTypes'
import type { DigestedSchemaField } from '@wix/wix-data-client-common-standalone'

const findField = (
  fields: DigestedSchemaField[] | { [fieldName: string]: FieldSpec },
  fieldName: string | undefined,
) => {
  if (!fieldName) {
    return
  }

  if (Array.isArray(fields)) {
    return fields.find(field => field.name === fieldName)
  }

  const field = fields[fieldName]
  return field && { ...field, name: fieldName }
}

type PartialSchema = Pick<Schema, 'plugins' | 'storage'> & {
  fields: DigestedSchemaField[] | { [fieldName: string]: FieldSpec }
}

export const isFieldAllowedInRoutingUrl = (
  schema: PartialSchema,
  fieldName: string | undefined,
): boolean => {
  const field = findField(schema.fields, fieldName)

  if (!field) {
    return false
  }

  if (!SUPPRTED_FIELD_TYPES_IN_URL.includes(field.type)) {
    return false
  }

  if (field.sortable === false) {
    return false
  }

  const schemaSupportsUrlizedV1 =
    !schema.plugins?.urlized || schema.plugins?.urlized?.format === 'original'
  const fieldSupportsAllDefaultOperators = !field.queryOperators
  const fieldSupportsUrlized = field.queryOperators?.includes(
    AllowedFilterOperator.urlized,
  )
  const fieldSupportsEq = field.queryOperators?.includes(
    AllowedFilterOperator.eq,
  )

  const fieldSupportsRequiredOperators = schemaSupportsUrlizedV1
    ? fieldSupportsAllDefaultOperators || fieldSupportsUrlized
    : fieldSupportsEq

  if (!fieldSupportsRequiredOperators) {
    return false
  }

  const isTPACollection = isDbDriverCollection(schema)

  if (isOwnerField(field) && !isTPACollection) {
    return false
  }

  return true
}
